'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zM4 12c0-4.4 3.6-8 8-8 1.8 0 3.5.6 4.9 1.7L5.7 16.9C4.6 15.5 4 13.8 4 12zm8 8c-1.8 0-3.5-.6-4.9-1.7L18.3 7.1C19.4 8.5 20 10.2 20 12c0 4.4-3.6 8-8 8z' });

var DoNotDisturbAlt = function DoNotDisturbAlt(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

DoNotDisturbAlt = (0, _pure2.default)(DoNotDisturbAlt);
DoNotDisturbAlt.muiName = 'SvgIcon';

exports.default = DoNotDisturbAlt;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/DoNotDisturbAlt.js
// module id = 2329
// module chunks = 0